export default (errors: { [key: string]: string[] }) => {
  const initialArray: string[] = []

  return Object.keys(errors).reduce((arr, field) => {
    errors[field].forEach((error: string) => {
      arr.push(`${field}: ${error}`)
    })
    return arr
  }, initialArray)
}
